import { LitElement as u, unsafeCSS as d } from "lit";
import { property as s } from "lit/decorators.js";
import b from "../../shared/reset.style.css.js";
import { booleanType as r } from "../../utils/property-types.js";
import m from "./header-links.style.css.js";
import { headerLinksTemplate as f } from "./header-links.template.js";
var c = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, i = (h, e, t, o) => {
  for (var p = o > 1 ? void 0 : o ? _(e, t) : e, a = h.length - 1, n; a >= 0; a--)
    (n = h[a]) && (p = (o ? n(e, t, p) : n(p)) || p);
  return o && p && c(e, t, p), p;
};
class l extends u {
  constructor() {
    super(...arguments), this.jcef = !1, this.configLabel = "Centre de configuració", this.hideConfig = !1, this.disableConfig = !1, this._hideHelp = !1, this._disableHelp = !1, this._helpLabel = "Ajuda", this._items = [];
  }
  static get styles() {
    return [d(b), d(m)];
  }
  set hideHelp(e) {
    const t = this._hideHelp;
    this._hideHelp = e, this.requestUpdate("hideHelp", t);
  }
  get hideHelp() {
    return this._hideHelp;
  }
  set disableHelp(e) {
    const t = this._disableHelp;
    this._disableHelp = e, this.requestUpdate("disableHelp", t);
  }
  get disableHelp() {
    return this._disableHelp;
  }
  set helpLabel(e) {
    const t = this._helpLabel;
    this._helpLabel = e, this.requestUpdate("helpLabel", t);
  }
  get helpLabel() {
    return this._helpLabel;
  }
  set items(e) {
    const t = this._items;
    this._items = e, this.requestUpdate("items", t);
  }
  get items() {
    return this._items;
  }
  /* METHODS */
  _dispatchItemAction(e) {
    const t = {
      detail: e,
      bubbles: !0,
      composed: !0
    };
    this.dispatchEvent(new CustomEvent("onClickLink", t));
  }
  _handleHelp() {
    this.dispatchEvent(new CustomEvent("onHelp", { bubbles: !0, composed: !0 }));
  }
  _handleConfig() {
    this.dispatchEvent(new CustomEvent("config", { bubbles: !0, composed: !0 }));
  }
  render() {
    return f(this);
  }
}
i([
  s(r)
], l.prototype, "jcef", 2);
i([
  s({ type: String })
], l.prototype, "configLabel", 2);
i([
  s(r)
], l.prototype, "hideConfig", 2);
i([
  s(r)
], l.prototype, "disableConfig", 2);
i([
  s(r)
], l.prototype, "hideHelp", 1);
i([
  s(r)
], l.prototype, "disableHelp", 1);
i([
  s({ type: String })
], l.prototype, "helpLabel", 1);
i([
  s({ type: Array })
], l.prototype, "items", 1);
export {
  l as HeaderLinks
};
//# sourceMappingURL=header-links.js.map
